module.exports = [{"date":1582313472,"uuid":"bf132192-9284-4391-b37f-0bccc52e5314","action_id":1,"is_statement":false,"url_content":"https://s3.us-west-2.amazonaws.com/porcobrar.com/emails/dev/1582312746789.QPB_hOkWTvOovJ8g4T7R8Q.json","invoice_collection":2078,"mode":1,"contact_type":1,"status":1,"activities":[]}]


//////////////////
// WEBPACK FOOTER
// ./src/redux/resources/reminder_example.json
// module id = 933
// module chunks = 33